<div *ngFor="let err of errors">
  <img src="assets/images/error.svg" class="me-1 error-icon" />
  <span class="error-message">{{ err.message }}</span>
</div>
